import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { useIntl } from 'react-intl';
import { nextAsset } from '../../../../components/nextAsset';
import { SmartlinksReleasePageTop } from './SmartlinksReleasePageTop';
import { Footer } from '../../../../layouts/Footer';
import { SmartlinksFeatures } from '../SmartlinksFeatures';
import { SmartlinksPageExplore } from '../SmartlinksPageExplore';
import { SmartlinksDescriptionRelease } from './SmartlinksDescriptionRelease';
import { SmartlinksMarketingRelease } from './SmartlinksMarketingRelease';

/* eslint-disable react/no-danger */
export const ReleasePage: NextPage = React.memo(() => {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: 'sml.web.smart-links.release.title',
    defaultMessage: 'Release Link'
  });
  const description = intl.formatMessage({
    id: 'sml.web.smart-links.release.description',
    defaultMessage: 'Promote your recent single or album across all streaming services.'
  });
  const promoImage = nextAsset(`images/smartLinks/release/preview.png`, false, { w: 1200 });
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="twitter:title" content={title} key="twitter-title" />
        <meta property="og:title" content={title} key="fb-title" />
        <meta itemProp="description" content={description} key="itemProp-description" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="fb-description" />
        <meta property="twitter:description" content={description} key="twitter-description" />
        <meta itemProp="image" content={promoImage} key="image" />
        <meta property="twitter:image" content={promoImage} key="twitter-image" />
        <meta property="twitter:image:width" content="1200" key="twitter-image-width" />
        <meta property="twitter:image:height" content="600" key="twitter-image-height" />
        <meta property="og:image" content={promoImage} key="fb-image" />
      </Head>
      <SmartlinksReleasePageTop />
      <SmartlinksDescriptionRelease />
      <SmartlinksMarketingRelease />
      <SmartlinksFeatures />
      <SmartlinksPageExplore hideRelease subPageName="Release Link" />
      <Footer />
    </>
  );
});
